import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as models from '../../../utils/models';

class ETCoverForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		scopeOfWork: Joi.string().min(5).required().label('Scope Of Work'),
		veProcedure: Joi.string()
			.min(5)
			.required()
			.label('Visual Examination Procedure'),
		eceProcedure: Joi.string()
			.min(5)
			.required()
			.label('Eddy Current Examination Procedure'),
		ndtQualification: Joi.string()
			.min(3)
			.required()
			.label('Qualification of NDT Personnel'),
		nonDestructiveTesting: Joi.string()
			.min(3)
			.required()
			.label('Non Destructive Testing'),
		damageMechanisms: Joi.string()
			.min(3)
			.required()
			.label(
				'Damage Mechanisms affecting Fixed Equipment in the Refining Industry'
			),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'scopeOfWork',
							label: 'Scope of work',
							placeholder: 'Enter Scope of Work',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'veProcedure',
							label: 'Visual Examination Procedure',
							placeholder: 'Enter Visual Examination Procedure',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'eceProcedure',
							label: 'Eddy Current Examination Procedure',
							placeholder: 'Enter Eddy Current Examination Procedure',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'ndtQualification',
							label: 'Qualification of NDT Personnel',
							placeholder: 'Enter Qualification of NDT Personnel',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'nonDestructiveTesting',
							label: 'Non Destructive Testing',
							placeholder: 'Enter Non Destructive Testing Criteria',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'damageMechanisms',
							label: 'Damage Mechanisms affecting Fixed Equipment',
							placeholder: 'Enter Damage Mechanisms affecting Fixed Equipment',
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default ETCoverForm;

const initialData: models.ETCoverData = {
	scopeOfWork: '',
	veProcedure: '',
	eceProcedure: '',
	ndtQualification: '',
	nonDestructiveTesting: '',
	damageMechanisms: '',
};
